import { environment } from "../environments/environment";

export const LOCAL_STORAGE_REDIRECT_URL = 'redirectUrl';
export const REDIRECT_FOR_LOGIN_URL = `${environment.catalogUrl}/login/instructure?redirect_to=AdminUi`;
export const REFRESH_TOKEN_FROM_CATALOG_INTERVAL = 60000 * 60 * 30 // 3 minutes
